/**
 * Auth Service - API calls for authentication with Supabase Auth support
 */

import api from './api';
import { signInWithProvider as supabaseOAuth } from '../config/supabase';

// Standard auth endpoints
export const register = (data) => api.post('/auth/register', data);

export const login = (data) => api.post('/auth/login', data);

export const logout = () => api.post('/auth/logout');

export const getMe = () => api.get('/auth/me');

export const refreshToken = (refreshToken) => api.post('/auth/refresh-token', { refreshToken });

export const forgotPassword = (email) => api.post('/auth/forgot-password', { email });

export const resetPassword = (data) => api.post('/auth/reset-password', data);

export const verifyEmail = (data) => api.post('/auth/verify-email', data);

export const resendVerification = (email) => api.post('/auth/resend-verification', { email });

export const changePassword = (data) => api.post('/auth/change-password', data);

// OAuth endpoints
export const getOAuthUrl = (provider) => api.get(`/auth/oauth/${provider}`);

export const handleOAuthCallback = (code) => api.get(`/auth/oauth/callback?code=${code}`);

// Client-side OAuth (using Supabase directly)
export const signInWithOAuth = async (provider) => supabaseOAuth(provider);

export default {
  register,
  login,
  logout,
  getMe,
  refreshToken,
  forgotPassword,
  resetPassword,
  verifyEmail,
  resendVerification,
  changePassword,
  getOAuthUrl,
  handleOAuthCallback,
  signInWithOAuth
};
